import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user2",
  "use": "icon-user2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user2\"><defs><style></style></defs><path d=\"M501.66 525.953c115.01 0 208.293-93.246 208.293-208.293S616.67 109.367 501.659 109.367c-115.02 0-208.293 93.246-208.293 208.293-.009 115.056 93.273 208.293 208.293 208.293zm-2.448 119.03c-229.805 0-383.343 123.365-463.322 297.566h952.22c-79.916-174.201-259.093-297.566-488.898-297.566z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol